
import React from 'react';
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const DemolitionProcess = () => {
  return (
    <div className="mt-16 bg-white rounded-lg shadow-lg p-8">
      <h2 className="text-2xl font-bold text-fabre-gray mb-6 text-center">Notre processus d'intervention</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
        <div className="p-4 text-center">
          <div className="bg-fabre-lightgreen rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4">
            <span className="text-fabre-green text-2xl font-bold">1</span>
          </div>
          <h3 className="font-bold text-lg mb-2">Étude technique</h3>
          <p className="text-gray-600">Analyse approfondie du site et des structures</p>
        </div>
        
        <div className="p-4 text-center">
          <div className="bg-fabre-lightgreen rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4">
            <span className="text-fabre-green text-2xl font-bold">2</span>
          </div>
          <h3 className="font-bold text-lg mb-2">Planification</h3>
          <p className="text-gray-600">Élaboration d'un plan d'intervention détaillé</p>
        </div>
        
        <div className="p-4 text-center">
          <div className="bg-fabre-lightgreen rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4">
            <span className="text-fabre-green text-2xl font-bold">3</span>
          </div>
          <h3 className="font-bold text-lg mb-2">Démolition</h3>
          <p className="text-gray-600">Exécution méthodique selon le plan établi</p>
        </div>
        
        <div className="p-4 text-center">
          <div className="bg-fabre-lightgreen rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4">
            <span className="text-fabre-green text-2xl font-bold">4</span>
          </div>
          <h3 className="font-bold text-lg mb-2">Valorisation</h3>
          <p className="text-gray-600">Gestion et recyclage des matériaux récupérés</p>
        </div>
      </div>
      
      <div className="mt-8 text-center">
        <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
          <Link to="/contact">
            Demander une étude
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default DemolitionProcess;
